export default function Footer() {
	const scrollToSection = (sectionId: string) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<footer className="bg-gray-900 text-white">
			<div className="container mx-auto px-4 py-12">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
					{/* Coluna da esquerda (Logo + descrição + redes sociais) */}
					<div className="space-y-6">
						<div className="flex items-center space-x-3">
							<div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
								<i className="ri-calculator-line text-white text-xl"></i>
							</div>
							<h3
								className="text-xl font-bold"
								style={{ fontFamily: "DM Sans, sans-serif" }}
							>
								Contabilidade Renzi Rossi
							</h3>
						</div>

						<p className="text-gray-300 leading-relaxed max-w-md text-justify">
							Atendimento 100% humanizado com foco no crescimento
							sustentável do seu negócio. Combinamos tradição e
							modernidade para oferecer soluções contábeis
							eficientes e transparentes.
						</p>

						{/* Redes sociais — atualizado */}
						<div className="flex items-center gap-3 mt-4">
							<a
								href="https://wa.me/551146381343"
								target="_blank"
								rel="noopener noreferrer"
								className="w-10 h-10 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-all duration-200 hover:scale-105"
								aria-label="WhatsApp"
							>
								<i className="ri-whatsapp-line text-white text-xl"></i>
							</a>

							<a
								href="https://instagram.com/contabilidaderenzirossi"
								target="_blank"
								rel="noopener noreferrer"
								className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 transition-all duration-200 hover:scale-105"
								aria-label="Instagram"
							>
								<i className="ri-instagram-line text-white text-xl"></i>
							</a>

							<a
								href="mailto:contato@renzirossi.com.br"
								className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 hover:bg-blue-700 transition-all duration-200 hover:scale-105"
								aria-label="E-mail"
							>
								<i className="ri-mail-line text-white text-xl"></i>
							</a>
						</div>
					</div>

					{/* Colunas fixas lado a lado — Navegação e Contato */}
<div className="container">
  <div className="nav-contact">
    {/* Navegação */}
    <div>
      <h4
        className="text-lg font-semibold mb-4"
        style={{ fontFamily: "DM Sans, sans-serif" }}
      >
        Navegação
      </h4>
      <ul className="space-y-2">
        <li>
          <button
            onClick={() => scrollToSection("inicio")}
            className="text-gray-300 hover:text-white transition-colors duration-200"
          >
            Início
          </button>
        </li>
        <li>
          <button
            onClick={() => scrollToSection("servicos")}
            className="text-gray-300 hover:text-white transition-colors duration-200"
          >
            Serviços
          </button>
        </li>
        <li>
          <button
            onClick={() => scrollToSection("sobre")}
            className="text-gray-300 hover:text-white transition-colors duration-200"
          >
            Sobre Nós
          </button>
        </li>
        <li>
          <button
            onClick={() => scrollToSection("contato")}
            className="text-gray-300 hover:text-white transition-colors duration-200"
          >
            Contato
          </button>
        </li>
      </ul>
    </div>

    {/* Contato */}
    <div>
      <h4
        className="text-lg font-semibold mb-4"
        style={{ fontFamily: "DM Sans, sans-serif" }}
      >
        Contato
      </h4>
      <div className="space-y-3">
        <div className="flex items-start space-x-3">
          <i className="ri-map-pin-line text-blue-400 mt-1"></i>
          <p className="text-gray-300 text-sm leading-relaxed">
            R. Alberto Rossi, 31
            <br />
            Centro, Poá - SP
            <br />
            CEP: 08561-620
          </p>
        </div>

        <div className="flex items-start space-x-3">
          <i className="ri-phone-line text-blue-400 mt-1"></i>
          <p className="text-gray-300 text-sm leading-relaxed">
            +55 11 4638-1343
            <br />
            +55 11 4638-5108
            <br />
            +55 11 4638-3842
          </p>
        </div>

        <div className="flex items-start space-x-3">
          <i className="ri-mail-line text-blue-400 mt-1"></i>
          <p className="text-gray-300 text-sm">
            contato@renzirossi.com.br
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* CSS interno */}
  <style>{`
    .nav-contact {
      display: flex;
      justify-content: space-between;
      gap: 2.5rem; /* gap-10 equivalente */
    }

    @media (max-width: 365px) {
      .nav-contact {
        flex-direction: column;
      }
    }
  `}</style>
</div>

				</div>

				<div className="border-t border-gray-800 mt-8 pt-8">
					<div className="flex flex-col md:flex-row justify-between items-center">
						<p className="text-gray-400 text-sm mb-4 md:mb-0">
							© 2024 Contabilidade Renzi Rossi. Todos os direitos
							reservados.
						</p>
					</div>
				</div>
			</div>
		</footer>
	);
}
